export class HrFilter {

    [key: string]: string[] | string;

    teamName: string[]
    year: string

    constructor() {
        this.teamName = [];
        this.year = '';
    }
}